import { rangeToBounds } from './analytics-shared.jsx';

// Explicit UTC calendar dates; incomplete/normalized invalid dates never fall
// back to a rolling window. Callers memoize this once per picker selection.
export function exactAnalyticsBounds(range, customRange) {
  try {
    if (range === 'custom') {
      for (const value of [customRange?.from, customRange?.to]) {
        if (
          !/^\d{4}-\d{2}-\d{2}$/.test(value ?? '') ||
          new Date(value + 'T00:00:00Z').toISOString().slice(0, 10) !== value
        )
          return null;
      }
    }
    const bounds = rangeToBounds(range, customRange);
    const width = +new Date(bounds.to) - +new Date(bounds.from) + 1;
    return width > 0 && width <= 365 * 86400_000
      ? { from: bounds.from, to: bounds.to }
      : null;
  } catch {
    return null;
  }
}


// A long Revenue/Traffic window also reads an equally long comparison period. Align
// rolling presets to whole UTC hours once that comparison can cross retention.
// Custom dates already represent complete UTC days; short presets stay exact.
export function exactComparisonBounds(range, customRange) {
  const bounds = exactAnalyticsBounds(range, customRange);
  if (!bounds || range === 'custom') return bounds;
  const from = +new Date(bounds.from), to = +new Date(bounds.to), span = to - from;
  if (span * 2 <= 90 * 86400_000) return bounds;
  const end = Math.floor(to / 3600_000) * 3600_000 + 3599_999;
  return { from: new Date(end - Math.round(span / 3600_000) * 3600_000 + 1).toISOString(), to: new Date(end).toISOString() };
}
